import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImagesSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImagesSparkle"><Path d="M18.4 2H17.6L16.6 4.6L14 5.6V6.4L16.6 7.4L17.6 10H18.4L19.4 7.4L22 6.4V5.6L19.4 4.6L18.4 2Z" fill="currentColor"/><Path d="M18.4 2H17.6L16.6 4.6L14 5.6V6.4L16.6 7.4L17.6 10H18.4L19.4 7.4L22 6.4V5.6L19.4 4.6L18.4 2Z" fill="currentColor"/><Path d="M12 5H5V13.5859L8 10.5859L12 14.5859L14 12.5859L19 17.5859V12H21V21H3V3H12V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImagesSparkle;
